import { BreadcrumbJsonLd } from 'next-seo';
import PropTypes from 'prop-types';

import { toAbsoluteLink } from 'lib/links';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const Schema = ({ title, href }) => (
  <BreadcrumbJsonLd
    itemListElements={[
      {
        position: 1,
        name: placeholder('breadcrumbs.app'),
        item: APP.URL,
      },
      {
        position: 2,
        name: title,
        item: toAbsoluteLink(href),
      },
    ]}
  />
);

Schema.propTypes = {
  title: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default Schema;
